
import React, { useState, useEffect } from 'react'
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import './AddSuggestedPrice.css'
//components
import Button from '../../../../../components/Button/Button'
import Input from '../../../../../components/Input/Input'
import Modal from '../../../../../components/Modal/Modal';
//services
import { serviceSuggestedService } from '../../../../../services/serviceSuggested';

const AddSuggestedPrice = () => {
  const navigate = useNavigate()
  const { id } = useParams();
  const location = useLocation();
  const { edtiData, action } = location.state || {};
  const [formData, setFormData] = useState({
    name: '',
    price: ''
  })
  const [errors, setErrors] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState({ text: '', highlight: '' });
  const [modalMessage, setModalMessage] = useState('');
  const [error, setError] = useState(false);

  useEffect(() => {
    console.log('action:', action);
    console.log('edtiData:', edtiData);
    if (action === 'edit' && edtiData) {
      setFormData({
        name: edtiData.name || '',
        price: edtiData.price ? edtiData.price.toString() : ''
      });
    }
  }, [action, edtiData]);

  const handleChange = (field) => (e) => {
    setFormData((prev) => ({
      ...prev,
      [field]: e.target.value
    }))

    setErrors((prev) => {
      if (!prev?.[field]) return prev;
      const next = { ...prev };
      delete next[field];
      return next;
    });
  }

  const handleCancel = () => {
    navigate(-1)
  }

  const validateForm = () => {
    const newErrors = {};

    if (!formData.name?.trim()) {
      newErrors.name = 'Service name is required';
    }

    if (!formData.price?.trim()) {
      newErrors.price = 'Price is required';
    } else if (Number.isNaN(Number(formData.price))) {
      newErrors.price = 'Price must be a number';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleEditPercentages = async () => {
    try {
      if (!validateForm()) return;
      
      const response = await serviceSuggestedService.update(id, {
        service_name: formData.name,
        base_rate: parseFloat(formData.price) || 1,
        category_id: 0,
        description: "Suggested price for " + formData.name,
        is_active: 1
      });
      if (response.status === "success") {
        setModalTitle({ text: 'Suggested price edited', highlight: 'successfully' });
        setModalMessage('The suggested price has been edited successfully.');
        setError(false);
        setIsModalOpen(true);
      }else{
        setModalTitle({ text: 'Error editing', highlight: 'suggested price' });
        setModalMessage(response.message || 'An error occurred while editing the suggested price.');
        setError(true);
        setIsModalOpen(true);
      }
    } catch (error) {
      setModalTitle({ text: 'Error editing', highlight: 'suggested price' });
      setModalMessage(error.message || 'An error occurred while editing the suggested price.');
      setError(true);
      setIsModalOpen(true);
    }
  }

  const handleConfirm = async (e) => {
    try {
      const isValid = validateForm();
      console.log('Confirming form data:', isValid);
      console.log('Confirming form data errors:', errors);
      if (!isValid) return;
      
      const response = await serviceSuggestedService.create({
        service_name: formData.name,
        base_rate: parseFloat(formData.price) || 1,
        category_id: 0,
        description: "Suggested price for " + formData.name,
        is_active: 1
      });
      if (response.status === "success") {
        setModalTitle({ text: 'Suggested price created', highlight: 'successfully' });
        setModalMessage('The suggested price has been created successfully.');
        setError(false);
        setIsModalOpen(true);
      }else{
        setModalTitle({ text: 'Error creating', highlight: 'suggested price' });
        setModalMessage(response.message || 'An error occurred while creating the suggested price.');
        setError(true);
        setIsModalOpen(true);
      }
    } catch (error) {
      setModalTitle({ text: 'Error creating', highlight: 'suggested price' });
      setModalMessage(error.message || 'An error occurred while creating the suggested price.');
      setError(true);
      setIsModalOpen(true);
    }
  }

  const handleModalClose = () => {
    setIsModalOpen(false);
    if (!error) {
      navigate(-1);
    }
  };

  return (
    <div className="add-suggested-price-page">
      <div className="add-suggested-price-container">
        <h1 className="page-title">
          <span className="highlight">Insert</span> the following data
        </h1>

        <div className="form-section">
          <h2 className="section-title">General information</h2>

          <div className="input-group-add-suggested-price">
            <div className="form-field-add-suggested-price">
              <label>Name of service*</label>
              <Input
                type="text"
                value={formData.name}
                onChange={handleChange('name')}
                placeholder="Name of service"
                required
                size="small"
                error={errors.name}
              />
            </div>

            <div className="form-field-add-suggested-price">
              <label>Suggested charge amount*</label>
              <Input
                type="number"
                value={formData.price}
                onChange={handleChange('price')}
                placeholder="Amount of barterbuck"
                required
                size="small"
                error={errors.price}
              />
            </div>
          </div>
        </div>

        <div className="form-actions-add-suggested-price">
          <Button
            onClick={handleCancel}
            variant="warning"
            borderRadius={20}
          >
            Cancel
          </Button>
          {action === 'edit' ? (
            <Button
              onClick={handleEditPercentages}
              variant="secondary"
              borderRadius={20}
            >
              Edit percentages
            </Button>
          ) : (
            <Button
              onClick={handleConfirm}
              variant="primary"
              borderRadius={20}
            >
              Confirm
            </Button>
          )}
        </div>
        <Modal
          isOpen={isModalOpen}
          showCancelButton={false}
          onClose={handleModalClose}
          title={modalTitle}
          message={modalMessage}
          error={error}
          onConfirm={handleModalClose}
        />
      </div>
    </div>
  )
}

export default AddSuggestedPrice
